import { render } from "./AllClientsView.vue?vue&type=template&id=60959740"
import script from "./AllClientsView.vue?vue&type=script&lang=js"
export * from "./AllClientsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__